/**
 * User form container layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { pageTitleDecorator } from 'Decorators';
import { loadUserData, updateUser, clearUserData } from 'Actions/user';
import IconCard from 'Common/Cards/IconCard.jsx';
import UserForm from '../components/UserForm';

@connect(
    store => ({
        loading: store.userData.loading,
        success: store.userData.success,
        error: store.userData.error,
        userData: store.userData.user,
    }),
    dispatch => ({
        loadUserData: id => dispatch(loadUserData(id)),
        updateUser: data => dispatch(updateUser(data)),
        clearUserData: () => dispatch(clearUserData()),
    })
)
@pageTitleDecorator('users.general')
export default class UserFormContainer extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        match: PropTypes.object.isRequired,
        loading: PropTypes.bool,
        success: PropTypes.bool,
        error: PropTypes.bool,
        userData: PropTypes.object.isRequired,
        updateUser: PropTypes.func.isRequired,
        loadUserData: PropTypes.func.isRequired,
        clearUserData: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const { loadUserData, match } = this.props;
        loadUserData(match.params.id);
    }

    componentWillUnmount() {
        const { clearUserData } = this.props;

        clearUserData();
    }

    renderUserForm = () => {
        const { updateUser, userData } = this.props;

        return <UserForm onSubmit={updateUser} initialValues={userData} />;
    };

    render() {
        return (
            <IconCard
                backButton={{
                    to: '/users',
                    title: 'button.to.users',
                }}
                content={this.renderUserForm()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/UserEdit/containers/UserEdit.jsx